import {
  Accordion,
  AccordionItem,
  Group,
  NumberFormatter,
  SegmentedControl,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { useMemo, useState } from "react";
import { IconBrandLinkedin } from "@tabler/icons-react";
import LinkedinSummaryTop from "./summary/LinkedinSummaryTop";
import LinkedinSummary from "./summary/LinkedinSummary";
import ReportingInfo from "../ReportingInfo";
import { useReportingStore } from "../../../../stores/ReportingStore";
import { useLanguage } from "../../../../stores/LanguageStore";

const ReportingLinkedin = () => {
  const lang = useLanguage((s) => s.language);
  const [active, setActive] = useState("messages");
  const actualStatsDate = useReportingStore((s) => s.actualStatsDate);

  const statistics = useMemo(() => {
    const totals = actualStatsDate.reduce((acc, curr) => {
      Object.keys(curr).forEach((key) => {
        if (key !== "date") {
          acc[key] = (acc[key] || 0) + curr[key];
        }
      });
      return acc;
    }, {});
    return totals;
  }, [actualStatsDate]);

  const component = useMemo(() => {
    if (active === "messages") {
      return (
        <LinkedinSummary
          type={{
            field: "linkedin_message_sent",
            label: lang.reports.message_sent,
            type: "messages",
          }}
        />
      );
    }
    if (active === "invitations") {
      return (
        <LinkedinSummary
          type={{
            field: "linkedin_invitation_sent",
            label: lang.reports.invitation_sent,
            type: "invitations",
          }}
        />
      );
    }
    return (
      <LinkedinSummary
        type={{
          field: "linkedin_visit_profile",
          label: lang.reports.visited_profiles,
          type: "visits",
        }}
      />
    );
  }, [active, lang]);

  return (
    <Accordion variant="contained" radius={"md"} defaultValue={"activity"}>
      <AccordionItem value="activity" style={{ border: 0 }}>
        <Accordion.Control bg={"primary.0"}>
          <Group>
            <ThemeIcon
              variant="filled"
              radius={"md"}
              size={"lg"}
              color={"var(--mantine-color-blue-5)"}
            >
              <IconBrandLinkedin />
            </ThemeIcon>

            <Title order={3} fw={500}>
              {lang.reports.activity_linkedin}
            </Title>
            <ReportingInfo>
              <Text>{lang.reports.activity_linkedin_text}</Text>
            </ReportingInfo>

            <Text ml={"auto"} mr={32} size="lg">
              <b>
                <NumberFormatter value={statistics.linkedin_sent} />{" "}
              </b>
              {lang.reports.linkedin_actions}
            </Text>
          </Group>
        </Accordion.Control>

        <Accordion.Panel bg={"var(--mantine-color-primary-2)"}>
          <Stack align="center" pt={8}>
            <LinkedinSummaryTop active={active} setActive={setActive} />
            <SegmentedControl
              data={[
                {
                  label: lang.reports.messages,
                  value: "messages",
                },
                {
                  label: lang.reports.invitations,
                  value: "invitations",
                },
                {
                  label: lang.reports.visits,
                  value: "visits",
                },
              ]}
              value={active}
              onChange={setActive}
              size="lg"
            />

            {component}
          </Stack>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  );
};

export default ReportingLinkedin;
